export default "__VITE_ASSET__DbcU9Qyg__"